module.exports = __webpack_public_path__ + "assets/ubike4.jpg?25abadb3e6c4dbe49bcbb46842923a6e";